
































import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageComplaintsView",
  components: { BasePage, PageTitle, BaseForm, BaseButton },
  props: {
    mailToLink: { type: String, required: true },
    hasSupportEmail: { type: Boolean, required: true },
    values: { type: Object as () => Record<string, string> },
  },
  data() {
    return {
      isValid: true,
      manualValidation: () => {},
    };
  },
  computed: {
    supportChatLocation(): Location {
      return {
        name: "messages",
        params: {
          userId: "1",
        },
      };
    },
    fields(): FormFields {
      return [
        {
          name: "name",
          placeholder: $t("Name"),
          label: $t("Name"),
          rules: "required",
        },
        {
          name: "email",
          placeholder: $t("Email"),
          label: $t("Email"),
          autocomplete: "email",
          type: "email",
          rules: "required",
        },
        {
          name: "contentUrl",
          placeholder: $t("Url"),
          label: $t("Url"),
        },
        {
          name: "complaint",
          placeholder: $t("Complaint"),
          label: $t("Complaint"),
          type: "textarea",
          rules: "required",
        },
      ];
    },
  },
  methods: {
    update(values: FormValues) {
      const { name, email, contentUrl, complaint } = values;
      this.$emit("update", { name, email, contentUrl, complaint });
    },
    async checkValidation(e: MouseEvent) {
      await this.manualValidation();
      if (!this.isValid) {
        e.preventDefault();
      }
    },
  },
});
